import React from 'react';
import { Prayer } from '../types/prayer';

interface PrayerCardProps {
  prayer: Prayer;
  isNext: boolean;
  isCurrent: boolean;
}

const PrayerCard: React.FC<PrayerCardProps> = ({ prayer, isNext, isCurrent }) => {
  const getPrayerIcon = (id: string) => {
    const icons: Record<string, string> = {
      sobh: '🌅',
      dhohr: '☀️',
      aser: '🌤️',
      magreb: '🌅',
      isha: '🌙'
    };
    return icons[id] || '🕌';
  };

  return (
    <div className={`prayer-card ${isCurrent ? 'current' : ''} ${isNext && !isCurrent ? 'next' : ''}`}>
      <div className="flex items-center gap-4">
        {/* Icon */}
        <div className={`text-3xl ${isCurrent ? 'scale-110 transition-transform' : ''}`}>
          {getPrayerIcon(prayer.id)}
        </div>

        {/* Prayer names - Arabic primary */}
        <div className="flex-1 min-w-0">
          <h3 className="prayer-name leading-tight">{prayer.name.ar}</h3>
          <p className="prayer-name-en leading-tight">{prayer.name.en}</p>
        </div>

        {/* Time and status */}
        <div className="text-left">
          <p className="prayer-time leading-none">{prayer.time}</p>
          {isNext && !isCurrent && (
            <span className="status-badge next mt-2 inline-block">
              القادمة
            </span>
          )}
          {isCurrent && (
            <span className="status-badge current mt-2 inline-block">
              الحالية
            </span>
          )}
        </div>
      </div>

      {/* Progress indicator for current prayer */}
      {isCurrent && (
        <div className="mt-4">
          <div className="h-2 w-full bg-white/10 rounded-full overflow-hidden">
            <div
              className="h-full bg-gradient-to-l from-emerald-400 to-teal-500 rounded-full"
              style={{ width: '100%' }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default PrayerCard;
